import { XCircleIcon } from '@heroicons/react/solid'
import React from 'react'
import Modal from 'shared/components/base/pop-up/Modal'
import CrmLink from 'shared/components/CrmLink'

import { CreatedOp } from '..'
import successImg from './assets/success.png'

type PropType = {
  ops?: CreatedOp[]
  isVisible: boolean
  onClose: () => void
}

function ModalOpportunity(props: PropType) {
  const { isVisible, onClose, ops } = props

  return (
    <Modal
      className="flex flex-col px-5 pb-5"
      closable={false}
      visible={isVisible}
      onClose={onClose}
    >
      <div className="flex flex-col pb-3 text-center">
        <div className="absolute right-0 close">
          <XCircleIcon
            className="w-5 h-5 text-[#7E92A2] cursor-pointer mt-1 mr-4"
            onClick={onClose}
          />
        </div>
        <img
          src={successImg}
          className="block m-auto w-[100px] h-[72px] mt-4"
        />
        <p className="mt-5 text-base font-semibold text-green-cta">
          تماس شما با موفقیت ثبت شد
        </p>
        <div className="flex flex-col gap-2 mt-4">
          {ops && ops.length
            ? ops.map((item) => (
                <div
                  className="text-[13px] font-medium text-color-title"
                  key={item.id}
                >
                  هپی کال شما با نام{' '}
                  <CrmLink type="opportunity" id={item.id}>
                    <span className="mx-1 font-medium text-blue-400 text-3.25 underline">
                      {item.name}
                    </span>
                  </CrmLink>
                  ساخته شد
                </div>
              ))
            : null}
        </div>
      </div>
    </Modal>
  )
}

export default ModalOpportunity
